module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper list-item"
  }, [(_vm.item) ? _c('div', [_c('div', {
    staticClass: "campaign-holder"
  }, [_c('div', {
    staticClass: "campaign-container"
  }, [_c('p', {
    staticClass: "affiliate_id campaign-content"
  }, [_c('span', [_vm._v(_vm._s(_vm.item.country) + " - " + _vm._s(_vm.item.vertical))])]), _vm._v(" "), _vm._l((_vm.item.campaigns), function(campaign) {
    return _c('p', {
      key: campaign.campaign_id,
      staticClass: "campaign-list-item campaign-content"
    }, [_c('span', [_c('b', [_vm._v(_vm._s(campaign.campaign_id))]), _vm._v(" " + _vm._s(campaign.name))])])
  })], 2), _vm._v(" "), (_vm.$store.state.user.affiliate_id == '0') ? _c('div', {
    staticClass: "vertical-container"
  }, [_c('p', {
    staticClass: "vertical-content"
  }, [_vm._v(_vm._s(_vm.item.affiliate_id))])]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.item.strategies), function(strategy) {
    return _c('el-tag', {
      key: strategy.id,
      attrs: {
        "type": "primary"
      }
    }, [_vm._v(_vm._s(_vm.strategyMap[strategy.strategy] || strategy.strategy))])
  })], 2) : _c('div', [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "campaign-holder"
  }, [_c('div', {
    staticClass: "campaign-container no-results"
  }, [_c('p', [_c('span', [_vm._v("Sorry!")])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("No Rotators Available")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-460bb493","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rotator-list-item.vue
// module id = TchO
// module chunks = 1